$(document).ready(function() {
$(document).on('change', '.filter-ByService', function(){
    var service = $(this).val(),
        urlRoute = Routing.generate("fetch_trombino_byService",{
        'service': service,
        'pageTrombinoId': $('#pageTrombinoId').val()
    });
    $('.bloc-trombino-box').html("");
    $('.bloc-loading').show();
    $.ajax({
        url : urlRoute,
        method: 'POST',
        dataType: "json",
        success: function ( response ) {
            $('.bloc-loading').hide();
            $('.bloc-trombino-box').html(response.htmlResultData);
        },
        error: function () {
            alert('erreur !! Veuillez consulter le support de site');
        }
    });
});
});